import { SellerHasTournamentTicketListResponse } from "../../../../../../api/tournament-ticket";
import * as S from "./styles";

interface TicketSelectPopupProps {
  list: SellerHasTournamentTicketListResponse[];
  selectedId: number | null;
  onClose: () => void;
  onSelect: (ticket: SellerHasTournamentTicketListResponse | null) => void;
}

const TicketSelectPopup = ({
  list,
  selectedId,
  onClose,
  onSelect,
}: TicketSelectPopupProps) => {
  return (
    <S.Overlay>
      <S.Popup>
        <S.Header>
          <div className="title">부상 선택</div>
          <img
            src="/image-web/tournament/close.svg"
            alt="close"
            onClick={onClose}
          />
        </S.Header>

        <S.TicketList>
          {list.length === 0 ? (
            <S.EmptyMessage>보유 중인 티켓이 없습니다.</S.EmptyMessage>
          ) : (
            list.map((ticket) => (
              <S.TicketItem
                key={ticket.id}
                $selected={selectedId === ticket.id}
                $disabled={ticket.count <= 0}
                onClick={() => {
                  if (ticket.count <= 0) {
                    alert("보유 수량이 없어 선택할 수 없습니다.");
                    return;
                  }
                  onSelect(ticket);
                }}
              >
                <div className="name">{ticket.name}</div>
                <div className="info">
                  <span>
                    시상 래빗: {ticket.prizeValue.toLocaleString()} RB
                  </span>
                  <span>
                    보유:{" "}
                    {ticket.count === 999
                      ? "무제한"
                      : ticket.count.toLocaleString() + "장"}
                  </span>
                </div>
              </S.TicketItem>
            ))
          )}
        </S.TicketList>

        <S.ClearButton
          onClick={() => {
            onSelect(null);
          }}
        >
          선택 해제
        </S.ClearButton>
      </S.Popup>
    </S.Overlay>
  );
};

export default TicketSelectPopup;
